import { useEffect, useRef } from "react";

/**
 * Zurück-Taste / Wischen am Handy / Browser-Zurück schließt nur die große Ansicht (BUT-0032, 29.10.2026).
 *
 * Eine Vollbild-Ansicht (Bild groß, Foto-Vorschau …) ist nur ein Fenster über der Seite, hat aber keinen eigenen
 * Verlaufseintrag – „Zurück“ verließ deshalb die ganze Seite (Ralph: „bin ich wieder in Projekte-Auswahl“).
 * Dieser Baustein legt beim Öffnen einen eigenen Verlaufseintrag an:
 *   • Zurück/Wischen → Eintrag fällt weg, die Ansicht schließt, die Seite bleibt.
 *   • Schließen per X, Klick daneben oder Esc → der eigene Eintrag wird wieder entfernt (history.back()),
 *     es bleibt kein überzähliger Schritt zurück.
 *
 * Aufruf:  useZurueckSchliesst(offen, onClose)   – onClose muss die Ansicht schließen (State auf false/null).
 * Einmal hier, für alle Vollbild-Ansichten (ProjektBild, Eingänge vom Kunden, Portal-Fotos, Monteur-App).
 */
let eigenesBack = false;  // wir lösen history.back() selbst aus → dieses popstate ist kein „Zurück“ des Anwenders
let diesesPopIstEigen = false;
if (typeof window !== "undefined") {
  // vor allen anderen popstate-Zuhörern registriert (gleiche Reihenfolge wie Registrierung)
  window.addEventListener("popstate", () => { diesesPopIstEigen = eigenesBack; eigenesBack = false; });
}

export const useZurueckSchliesst = (offen, onClose) => {
  const schliessen = useRef(onClose);
  schliessen.current = onClose;

  useEffect(() => {
    if (!offen || typeof window === "undefined") return undefined;
    const marke = `zs-${Date.now()}-${Math.random().toString(36).slice(2)}`;
    let gesetzt = false;
    let geschlossenPerZurueck = false;
    // kurz verzögert: React-Entwicklungsmodus startet Effekte doppelt – so entsteht trotzdem nur ein Eintrag
    const timer = setTimeout(() => {
      try { window.history.pushState({ ...(window.history.state || {}), zsMarke: marke }, ""); gesetzt = true; } catch { /* ohne Verlauf: Ansicht schließt wie bisher nur per X */ }
    }, 0);
    const beiZurueck = () => {
      if (diesesPopIstEigen || !gesetzt) return;
      if (window.history.state?.zsMarke === marke) return;   // vorwärts auf unseren Eintrag: nichts tun
      geschlossenPerZurueck = true;
      schliessen.current?.();
    };
    window.addEventListener("popstate", beiZurueck);
    return () => {
      clearTimeout(timer);
      window.removeEventListener("popstate", beiZurueck);
      // geschlossen per X / Klick / Esc: eigenen Eintrag wieder entfernen, ohne die Seite zu verlassen
      if (gesetzt && !geschlossenPerZurueck && window.history.state?.zsMarke === marke) {
        eigenesBack = true;
        window.history.back();
      }
    };
  }, [offen]);
};
